import React, { useState, useEffect } from 'react';
import CallBackForm from '../Common/CallBackForm';
import * as Yup from 'yup';
import { useCreateQueryMutation } from '../Store/Features/ExitIntentAPI';
import { encode } from '../../utils/encrypt';
import { useRouter } from 'next/navigation';


const ExitIntentModal = ({ slug=null , referringUrl, shortDescription = null, title = null, product_name = null, page_name = "Report Profile", form_name = "exit-intent" }) => {
  const [showModal, setShowModal] = useState(false);
  const [createQuery, { isLoading, isError }] = useCreateQueryMutation()

  const fields = [
    {
      name: 'name',
      label: 'Name',
      validation: Yup.string().matches(/^[a-zA-Z\s]*$/, 'Name can only contain letters and spaces').required('Name is required'),
      customClass: 'md:col-span-6 col-span-12'
    },
    {
      name: 'email',
      type: 'email',
      label: 'Email',
      validation: Yup.string().email('Invalid email').required('Email is required'),
      customClass: 'md:col-span-6 col-span-12'
    }
  ];

  const options = {
    btn_name: "Send it to me"
  }

  const router = useRouter();

  const handleSubmit = (values) => {
    values.page_name = page_name;
    values.form_name = form_name;
    values.source_url = window.location.href;
    values.source_url_from = referringUrl;
    values.product_name = product_name;

    createQuery({ data: encode(values) }).then((response) => {
      if (response) {
        if (response.data.code == 200) {
          setTimeout(() => { 
            router.push('/thank-you');
          }, 1000);
        } else {
          alert(response.data.message)
        }

      } else {
        let res = {
          'message': "Error",
          'status': false
        }
      }
    })

  };

  const [memorizedData, setMemorizedData] = useState(false);

  const handleCloseModal = () => {
    setMemorizedData(true);
    setShowModal(false);
  };

  // Show modal on mouse leave
  const handleMouseLeave = () => {
    if (!memorizedData) {
      setShowModal(true);
    }
  };

  // Attach event listener when the component mounts
  useEffect(() => {
    document.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [memorizedData]); // Add memorizedData as a dependency to reattach the event listener when it changes


  return (
    <div className={`fixed inset-0 flex items-center lg:w-[70%] mx-auto z-50 justify-center w-[90%] ${showModal ? 'visible' : 'invisible'}`}>
      {/* Semi-transparent background overlay */}
      <div
        className={`fixed inset-0 bg-[#969696] opacity-80 ${showModal ? 'visible' : 'invisible'}`}
      ></div>
      {/* Modal */}
      <div className="relative w-full p-8 bg-white rounded shadow-lg">
        <div className="flex justify-end">
          <button
            className="text-gray-500 hover:text-gray-700 focus:outline-none"
            onClick={handleCloseModal}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        {/* <h2 className="text-2xl text-center text-[#1e5df3] pt-2 font-semibold capitalize">{title ? title : null} Sample Page</h2> */}
        {/* <p className="text-center">Get a Sneak Peek at the Latest {title ? title : null} Report</p> */}
        <h2 className="text-2xl text-center text-[#1e5df3] pt-2 font-semibold capitalize">{title}</h2>
        <p className="text-center capitalize">{shortDescription}</p>
        <div>
            
          <CallBackForm
            fields={fields}
            // onSubmit={handleSubmit}
            product_name={product_name}
            endpoint="/enquiry/exit-intent"
            options={options}
            captcha={false}
            form_name={form_name}
            page_name={page_name}
            isLoading={isLoading}
            slug={slug}
          />
        </div>
      </div>
    </div>
  );
};

export async function getServerSideProps({ req }) {
  // Capture the referring URL from the request headers
  const referringUrl = req.headers.referer || '/';

  return {
    props: {
      referringUrl,
    },
  };
}

export default ExitIntentModal;
